import { DetailedPosition, Target } from '@/tmp/Target';
import { GpsFixed, LocationOn, Schedule, Speed } from '@mui/icons-material';
import { fulldate } from '@/utilities/dateUtils';
import { isValidLatLong } from '@/utilities/latlong';
import { useTranslation } from 'react-i18next';
import FlagsWithGeoAdress from '@/components/common/FlagsWithGeoAddr';
import CurrentPositionActions from './CurrentPositionActions';

import './TargetTrackingDetails.css';

export default function TargetTrackingDetails({ target }: { target: Target }) {
  const currentPosition = target.currentPosition;
  const { t } = useTranslation();

  function getPositionAsCoordinates(currentPosition: DetailedPosition | null) {
    if (!isValidLatLong(currentPosition)) {
      return '';
    }
    return `${currentPosition!.latitude.toFixed(4)}, ${currentPosition!.longitude.toFixed(4)}`;
  }

  return (
    <div className="target-tracking-details">
      {currentPosition && currentPosition.geocodedAddress && (
        <div className="tracking-attribute important-attribute">
          <LocationOn className="attribute-icon" color="primary" />
          <FlagsWithGeoAdress
            countryCode={currentPosition.countryCode}
            countryName={currentPosition.countryName}
            geocodedAddress={currentPosition.geocodedAddress}
          />
        </div>
      )}
      <div className="tracking-attribute">
        <GpsFixed className="attribute-icon" color="primary" />
        <span>{getPositionAsCoordinates(currentPosition)}</span>
        <div className="position-action-buttons">
          <CurrentPositionActions contentText={getPositionAsCoordinates(currentPosition)} target={target} />
        </div>
      </div>
      {currentPosition && (
        <div className="tracking-attribute important-attribute">
          <Speed className="attribute-icon" color="primary" />
          <span>{currentPosition.speed} km/h</span>
        </div>
      )}
      {currentPosition && currentPosition.timeMicros && (
        <div className="tracking-attribute">
          <Schedule className="attribute-icon" color="primary" />
          <span>{fulldate(currentPosition.timeMicros, t)}</span>
        </div>
      )}
    </div>
  );
}
